/*
    payload: {
        date: '2020-03-20',
        photos: [

        ]
    }
    photoList: [
        {
            date: '2020-03-19',
            photos: [

            ]
        },
        {
            date: '2020-03-20',
            photos: [

            ]
        },
    ]
*/
/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        photoList: {}
    },

    getters: {
        photoList(state) {
            return state.photoList
        }
    },

    mutations: {
        setPhotos(state, payload) {
            state.photoList = payload
        },
/* --
        setPhotosByDate(state, payload) {
            // 日付が既にリストにある時
            var targetDateData = state.photoList.find(datePhotos => (datePhotos.date === payload))
            targetDateData.photos = payload.photos
            // 日付がまだリストに無い時
        },
        setPhotoById(state, payload) {
            state.photoList.each(datePhoto => {
                var thePhoto = datePhoto.photos.find(photo => {
                    photo.id = payload.id
                })
                console.log(thePhoto)
                thePhoto.arealist = payload.arealist
            })
        }
-- */
    },

    actions: {
        async updateFullList(context, apiPath) {
            await axios.get(
                apiPath + '/getFullData/'
            )
            .then(response => {
                var rtn = response.data
                if (rtn.status === 'OK') {
                    context.commit('setPhotos', rtn.data)
                } else {
                    context.commit('setPhotos', null)
                }
            })
            .catch(function (error) {
                context.commit('setPhotos', null)
            })
        }
    }
})

export default store
